module.exports = __webpack_public_path__ + "static/media/edit-column-icon.e5e22cfa.svg";